<template>
  <CallScreen logo="sos" title="Emergency Advisor" />
</template>

<script>
import CallScreen from "@/components/CallScreen";

export default {
  name: "Sos",
  components: {
    CallScreen
  }
};
</script>

<style lang="scss" scoped></style>
